import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/core/services/menu.service';

@Component({
  selector: 'ds-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  public lastRouteName: string;

  constructor(private router: Router, private menuService: MenuService) {}

  ngOnInit(): void {
    this.lastRouteName = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
    this.menuService.setApplicationTitle(this.lastRouteName);
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
